import { render } from "./BtnAtualizarStatusPix.vue?vue&type=template&id=63ca7c6a"
import script from "./BtnAtualizarStatusPix.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarStatusPix.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__